/**
 * @generated SignedSource<<a12223107133d5d4d0a1c30f5cd372b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contextsArticleListContextProviderArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "contextsArticleListContextProviderArticle";
};
export type contextsArticleListContextProviderArticle$key = {
  readonly " $data"?: contextsArticleListContextProviderArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"contextsArticleListContextProviderArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "contextsArticleListContextProviderArticle"
};

(node as any).hash = "7d3d16dea7bd93149de2d8155d2d4ddf";

export default node;
